import { getDB } from "../utils";

const STORE = "timbrate_scartate";

function normalizeRejectedTimbrata(record) {
  if (!record) throw new Error("Record timbrata scartata non valido");
  if (!record.user_id) throw new Error("Timbrata scartata senza user_id");
  return {
    id: record.id || `timbrata_scartata_${Date.now()}_${Math.random().toString(16).slice(2)}`,
    user_id: record.user_id,
    assunzione_id: record.assunzione_id || null,
    tipo: record.tipo || null,
    data_riferimento: record.data_riferimento || null,
    location_id: record.location_id || null,
    mode_localizzazione: record.mode_localizzazione || null,
    gps_distance: Number.isFinite(Number(record.gps_distance)) ? Number(record.gps_distance) : null,
    gps_accuracy: Number.isFinite(Number(record.gps_accuracy)) ? Number(record.gps_accuracy) : null,
    gps_tolleranza: Number.isFinite(Number(record.gps_tolleranza)) ? Number(record.gps_tolleranza) : null,
    gps_result: record.gps_result || null,
    gps_reason: record.gps_reason || null,
    created_at: record.created_at || new Date().toISOString(),
  };
}

export async function addRejectedTimbrata(record) {
  const normalized = normalizeRejectedTimbrata(record);
  const db = await getDB();
  await db.put(STORE, normalized);
  return normalized;
}